module.exports = __webpack_public_path__ + "img/txtc_btn_mingrizailai.d5a7cf4b.png";